import styled from 'styled-components'

export const LoginLink = styled.a`
  color: ${({ theme }) => theme.colors.inverseColor};
  font-weight: bold;
  line-height: 1;
  padding-left: 3px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
